var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.556v8.552H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99 9.661H2.579a.24.24 0 0 1-.24-.24V6.012h-.001l4.066-4.066H0V12h10.054V5.598L5.99 9.66z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.298.999 7.552.256a.878.878 0 0 0-1.24 0L6.01.562l.005.006-5.943 5.93a.24.24 0 0 0-.071.17v1.645c0 .133.108.24.24.24h1.646a.24.24 0 0 0 .17-.07l6.062-6.05-.005-.006.186-.187A.877.877 0 0 0 8.298 1",
    fill: "currentColor",
    mask: "url(#1ifh8sqjkb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.45c96406a4420bf2520774dcd39b4423.svg";
export { ForwardRef as ReactComponent };